namespace Vit.Administration {
    @Serenity.Decorators.registerClass()
    export class TenantEditDialog extends Vit.GridEditorDialog<TenantRow> {
        protected form = new TenantForm(this.idPrefix);

        protected getFormKey() {
            return TenantForm.formKey;
        }

        protected getLocalTextPrefix() {
            return TenantRow.localTextPrefix;
        }


        protected getNameProperty() {
            return TenantRow.nameProperty;
        }

    }
}